// extracted by mini-css-extract-plugin
export default {"link":"cLFeeoiOBdaPjhLSO2GQ","primary":"CZiTkspwr9H8jNAprB9o","secondary1":"L7CP7eA1SXdhDd1NpvwC","secondary2":"qtRskkDF4EgRnCBosHTg","disabled":"Mf5ymg6m3txYzcP3_FSy"};